import {
  CheckCircleOutlined
} from "@ant-design/icons";
import { hasNodes } from "../../utils/hasNodes";


export const getSidebarActions = ( t, nodes ) => [
  {
    type: "descriptionIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.description"),
    disabled: hasNodes({type:"descriptionIntentNode", nodes}),
  },
  {
    type: "defaultResponseIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.default_response"),
    disabled: hasNodes({type:"defaultResponseIntentNode", nodes}),
  },
  {
    type: "parameterIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.parameter"),
    disabled: hasNodes({type:"parameterIntentNode", nodes}),
  },
  {
    type: "entryIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.phrases"),
    disabled: hasNodes({type:"entryIntentNode", nodes}),
  },
  {
    type: "extensionIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.extension"),
    disabled: hasNodes({type:"extensionIntentNode", nodes}),
  },
  {
    type: "responseIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.responses"),
    disabled: hasNodes({type:"responseIntentNode", nodes}),
  },
  {
    type: "integrationIntentNode",
    icon: CheckCircleOutlined,
    label: t("common:intents.flow_chat.integration"),
    disabled: hasNodes({type:"integrationIntentNode", nodes}),
  },
];


